export default __webpack_public_path__ + "static/media/bank.5f939796.svg";